var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 29.3356C23.3636 29.3356 29.3332 23.3661 29.3332 16.0023C29.3332 8.63848 23.3636 2.66895 15.9998 2.66895C8.63604 2.66895 2.6665 8.63848 2.6665 16.0023C2.6665 23.3661 8.63604 29.3356 15.9998 29.3356Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.3356L19.3333 16.0023L14 12.6689V19.3356Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 9.33496C19.6668 9.33496 22.6668 12.319 22.6668 16.0016C22.6668 19.6843 19.6828 22.6683 16.0002 22.6683C12.3175 22.6683 9.3335 19.6843 9.3335 16.0016C9.3335 12.319 12.3335 9.33496 16.0002 9.33496Z",
    stroke: "white",
    strokeWidth: 2.08333,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeMusic);
export default __webpack_public_path__ + "static/media/youtube-music.2a9d1e4d36b058cc70da56f993dd60d4.svg";
export { ForwardRef as ReactComponent };